import React from 'react'
import styled from 'styled-components'
import {Route} from 'react-router-dom'
import ReactGA from 'react-ga'

import {Start} from './start/Start'
import {Category} from './category/Category'
import {Video} from './video/Video'
import {VideoEnd} from './video-end/VideoEnd'
import {FullSizeInContainer} from './common/StyledComponents'

const Container = styled.div`
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
  background-color: #fff;
  color: #000;

  a {
    color: #000;
  }
`

export const App = () => {
  return (
    <Container>
      <FullSizeInContainer>
        <Route
          path="*"
          render={() => {
            ReactGA.pageview(window.location.pathname + window.location.search)
            return null
          }}
        />
        <Route exact path="/" component={Start} />
        {/*<Route exact path="/:locale" component={Home} />*/}
        <Route exact path={'/:locale/category/:categoryKey'} component={Category} />
        <Route exact path={'/:locale/category/:categoryKey/video/:videoKey'} component={Video} />
        <Route exact path={'/:locale/category/:categoryKey/video/:videoKey/end'} component={VideoEnd} />
      </FullSizeInContainer>
    </Container>
  )
}
